export const buildTeamRolePayload = (form, editingRole = null) => ({
    name: form.name.trim(),
    isTeamLead: form.isTeamLead,
    ...(editingRole ? { colorHex: editingRole.colorHex } : {}),
});
